<template>
  <video class="game_video d-none" width="100%" ref="videoPlayer"
         id="bgvid" playsinline autoplay muted>
    <source :src="videoUrl" type="video/mp4">
    Your browser does not support HTML video.
  </video>
</template>

<script>
export default {
  name: 'video-game',
  props: {
    videoUrl: {
      type: String,
      default: null,
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/game/Video.vue